import { cn } from '../../lib/utils';
import React, { HTMLAttributes } from 'react'

const keyframesStyle = `
    @keyframes spinner_spin {
      0% {
          opacity: 1;
      }

      to {
          opacity: .15;
      }
    }
  `;

interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
    bgColor?: string;
}

const Spinner = ({className, bgColor='white', ...props}:SpinnerProps) => {
  return (
    <div className={cn('relative w-5 h-5', className)} {...props}>
        <style>{keyframesStyle}</style>
        <div className='relative w-[inherit] h-[inherit] top-1/2 left-1/2'>
          {Array(12).fill('').map((_,i)=>(
            <div
            key={i}
            className='rounded-sm h-[8%] w-[24%] absolute left-[-10%] top-[-3.9%]'
            style={{
                backgroundColor: bgColor,
                animation: 'spinner_spin 1.2s linear infinite',
                animationDelay: `${-1.3 + 0.1 * i}s`,
                transform: `rotate(${30 * i}deg) translate(146%)`,
            }}
          ></div>
          ))}
        </div>
      </div>
  )
}

export default Spinner